import React from 'react';
import { useFadeIn } from '../hooks/useFadeIn';
export function IncludedSection() {
  const fadeIn = useFadeIn();
  const benefits = [{
    emoji: '💬',
    text: 'Focus faster and without frustration'
  }, {
    emoji: '😄',
    text: 'Finish activities feeling proud and confident'
  }, {
    emoji: '💖',
    text: 'Handle big emotions with calm'
  }, {
    emoji: '⏰',
    text: 'Learn more in less time'
  }, {
    emoji: '🌈',
    text: 'Rebuild confidence in themselves'
  }, {
    emoji: '✨',
    text: 'Choose brain activities over screens'
  }, {
    emoji: '🧠',
    text: "Develop the skills that schools don't teach,"
  }, {
    emoji: '🎯',
    text: 'Build a strong cognitive foundation'
  }];
  return <section className="py-16 px-4 bg-white" data-id="element-138">
      <div className="max-w-3xl mx-auto" data-id="element-139">
        <div ref={fadeIn.ref} className={fadeIn.className} data-id="element-140">
          <div className="text-center mb-10 md:mb-12" data-id="element-141">
            <h2 className="text-3xl md:text-5xl font-black text-gray-900 mb-4" data-id="element-142">
              💙 What Your Child Will Gain
            </h2>
            <div className="w-24 h-2 bg-blue-600 mx-auto rounded-full" data-id="element-143"></div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-144">
            {benefits.map((b, i) => <div key={i} className="bg-blue-50 p-5 rounded-xl flex gap-4 items-center border border-blue-100" data-id="element-145">
                <span className="text-3xl flex-shrink-0" data-id="element-146">{b.emoji}</span>
                <p className="text-base md:text-lg text-gray-800 font-bold" data-id="element-147">
                  {b.text}
                </p>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}